import { render, staticRenderFns } from "./updatePwa.vue?vue&type=template&id=be8005b0"
import script from "./updatePwa.vue?vue&type=script&lang=js"
export * from "./updatePwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports